// import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Components/Home/Home";
import Card from "./Components/Cards/CreditCard/Card";
import Loan from "./Components/Loan/Loan";
import FixedDeposit from "./Components/Investments/FixedDeposit";
import FdAxis from "./Components/Investments/FdAxis";
import FdBandhan from "./Components/Investments/FdBandhan"
import Compare from "./Components/Compare/Compare";
import BankInnerPage from "./Components/BankInnerPage/BankInnerPage";
import Investments from "./Components/Loan/Investments";
import AboutUs from "./Components/About/AboutUs";
import ContactUs from "./Components/Contact/ContactUs";
import axios from "axios";
import BankInnerPage1 from "./Components/BankInnerPage/BankInnerPage1";
import LoanData from "./LoanData"
import InvestmentData from "./InvestmentData"

function App() {
  return (
    <>
      <BrowserRouter>
      <Header />
        <Routes>
        <Route index element={<Home />} />

            <Route path="home"   element={<Home  />} />
          {/* <Route path="card"  element={<Card />} /> */}
          <Route path="loan"  element={<Loan />} />
          <Route path="investments"  element={<Investments />} />
          <Route path="fdaxis" element={<FdAxis />} />
          <Route path="fdbandan" element={<FdBandhan />} />
          <Route path="compare" element={<Compare/>} /> 
          <Route path="bankinnerpage" element={<BankInnerPage/>} /> 
          <Route path="bankinnerpage1" element={<BankInnerPage1/>} /> 
          <Route path="about" element={<AboutUs/>} /> 
          <Route path="contact" element={<ContactUs/>} />


          <Route path="loan-api" element={<LoanData/>} />
          <Route path="investment-api" element={<InvestmentData/>} />



          {/* <Home/> */}
          {/* <Card/> */}
          {/* <Loan /> */}
          
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
    // <div
    // onClick={()=>{
    //   axios.put("https://api.dremerz.net/api/infinitifutureslogindata/20",{
    //     username:"KPALANISWAMY"
    //   })
    // }}
    // >
    //   lol
    //   </div>
  );
}

export default App;



// import React from 'react'
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';



// export default function App() {

//   const [data, setData] = useState(null);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//       const fetchData = async () => {
//           try {
//               // Get the token
//               const tokenResponse = await axios.post('https://apigateway.indianbank.in/indianbank/open-api/app/oauth2/token', null, {
//                   params: {
//                       grant_type: 'client_credentials',
//                       client_id: 'your_client_id',
//                       client_secret: 'your_client_secret',
//                   },
//                   headers: {
//                       'Content-Type': 'application/x-www-form-urlencoded',
//                   },
//               });

//               const token = tokenResponse.data.access_token;

//               // Fetch the data
//               const response = await axios.get('https://apigateway.indianbank.in/indianbank/open-api/v1/your-endpoint', {
//                   headers: {
//                       Authorization: `Bearer ${token}`,
//                   },
//               });

//               setData(response.data);
//           } catch (error) {
//               setError(error);
//           }
//       };

//       fetchData();
//   }, []);

// const ApiComponent = () => {

//     if (error) {
//         return <div>Error: {error.message}</div>;
//     }

//     if (!data) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <div>
//             <h1>API Data</h1>
//             <pre>{JSON.stringify(data, null, 2)}</pre>
//         </div>
//     );
// };


//   return (
//     <div className="App">
//     <header className="App-header">
//         <ApiComponent />
//     </header>
// </div>
//   )
// }


// import axios from 'axios'
// import React from 'react'

// export default function App() {
//   return (
//     <div
//     onClick={()=>{
//       axios.post("https://api.dremerz.net/api/punagai",
        
//         {

//           "bankName": "Bank of Baroda ",
//           "desc": {
//             "desc1": "Bank of Baroda offers the Fixed Deposit (FD) scheme at attractive interest rates ranges from 3.00% p.a. to 7.25% p.a. with a tenure ranging between seven days and ten years.",
//             "desc2": "The bank offers three types of FDs - Short Term Deposits, Long Term Deposits, and Capital Gain Account Scheme, 1988. Senior citizens are provided an additional interest rate on the FD scheme."
//           },
//           "table": {
//             "tableheading": "Bank of Baroda Domestic Fixed Deposit Rates (Below Rs.2 crore)",
//             "tableContent": {
//               "headings": {
//                 "heading1": "Tenure",
//                 "heading2": "Interest Rates for General Public (p.a)",
//                 "heading3": "Interest Rates for Senior Citizens (p.a)"
//               },
//               "data": {
//                 "data1": {
//                   "Tenure": "7 days to 14 days",
//                   "Interest Rates for General Public (p.a.)": "4.25%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "4.75%"
//                 },
//                 "data2": {
//                   "Tenure": "15 days to 45 days",
//                   "Interest Rates for General Public (p.a.)": "4.50%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "5.00%"
//                 },
//                 "data3": {
//                   "Tenure": "46 days to 90 days",
//                   "Interest Rates for General Public (p.a.)": "5.50%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "6.00%"
//                 },
//                 "data4": {
//                   "Tenure": "91 days to 180 days",
//                   "Interest Rates for General Public (p.a.)": "5.60%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "6.10%"
//                 },
//                 "data5": {
//                   "Tenure": "181 days to 210 days",
//                   "Interest Rates for General Public (p.a.)": "5.75%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "6.25%"
//                 },
//                 "data6": {
//                   "Tenure": "211 days to 270 days",
//                   "Interest Rates for General Public (p.a.)": "6.15%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "6.65%"
//                 },
//                 "data7": {
//                   "Tenure": "271 days & above and less than 1 year",
//                   "Interest Rates for General Public (p.a.)": "6.25%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "6.75%"
//                 },
//                 "data8": {
//                   "Tenure": "360D (bob360)",
//                   "Interest Rates for General Public (p.a.)": "7.10%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "7.60%"
//                 },
//                 "data9": {
//                   "Tenure": "1 year",
//                   "Interest Rates for General Public (p.a.)": "6.85%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "7.35%"
//                 },
//                 "data10": {
//                   "Tenure": "Above 1 year to 400 days",
//                   "Interest Rates for General Public (p.a.)": "6.85%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "7.35%"
//                 },
//                 "data11": {
//                   "Tenure": "Above 400 days and up to 2 Years",
//                   "Interest Rates for General Public (p.a.)": "6.85%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "7.35%"
//                 },
//                 "data12": {
//                   "Tenure": "Above 2 Years and up to 3 Years",
//                   "Interest Rates for General Public (p.a.)": "7.25%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "7.75%"
//                 },
//                 "data13": {
//                   "Tenure": "Above 3 Years and up to 5 Years",
//                   "Interest Rates for General Public (p.a.)": "6.50%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "7.15%"
//                 },
//                 "data14": {
//                   "Tenure": "Above 5 Years and up to 10 Years",
//                   "Interest Rates for General Public (p.a.)": "6.50%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "7.50%"
//                 },
//                 "data15": {
//                   "Tenure": "Above 10 years (MACT/MACAD Court Order schemes only)",
//                   "Interest Rates for General Public (p.a.)": "6.25%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "6.75%"
//                 }
//               }
//             },
//             "note": " Bank of Baroda can change the interest rates at any given time without prior notice. The above-mentioned interest rates are effective from ** 15 January 2024**."
//           },
//           "table2": {
//             "tableheading": "Bank of Baroda Tax Savings Term Deposit Rates",
//             "tableContent": {
//               "headings": {
//                 "heading1": "Tenure",
//                 "heading2": "Interest Rates for General Public (p.a)",
//                 "heading3": "Interest Rates for Senior Citizens (p.a)"
//               },
//               "data": {
//                 "data1": {
//                   "Tenure": "5 years",
//                   "Interest Rates for General Public (p.a.)": "6.50%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "7.15%"
//                 },
//                 "data2": {
//                   "Tenure": "15 days to 29 days",
//                   "Interest Rates for General Public (p.a.)": "6.50%",
//                   "Interest Rates for Sr. Citizen (p.a.)": "7.50%"
//                 }
//               }
//             },
//             "note": "Bank of Baroda can change the interest rates at any given time without prior notice. The above-mentioned interest rates are effective from **15 January 2024.**"
//           },
//           "table3": {
//             "tableheading": "Bank of Baroda Bulk Deposit Rates (Above Rs.2 crore)",
//             "tableContent": {
//               "headings": {
//                 "heading1": "Tenure",
//                 "heading2": "Rs. 2.00 Crores up to Rs. 5.00 Crores ",
//                 "heading3": "Above Rs. 5.00 Crores up to Rs. 10.00 Crores "
//               },
//               "data": {
//                 "data1": {
//                   "Tenure": "7 days to 14 days",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "5.00%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "5.00%"
//                 },
//                 "data2": {
//                   "Tenure": "15 days to 45 days",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "5.00%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "5.00%"
//                 },
//                 "data3": {
//                   "Tenure": "46 days to 90 days",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "5.75%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "5.75%"
//                 },
//                 "data4": {
//                   "Tenure": "91 days to 180 days",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "5.75%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "5.75%"
//                 },
//                 "data5": {
//                   "Tenure": "181 days to 210 days",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "6.50%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "6.50%"
//                 },
//                 "data6": {
//                   "Tenure": "211 days to 270 days",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "6.75%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "6.75%"
//                 },
//                 "data7": {
//                   "Tenure": "271 days to less than 1Y",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "6.75%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "6.75%"
//                 },
//                 "data8": {
//                   "Tenure": "1 Year",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "7.45%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "7.55%"
//                 },
//                 "data9": {
//                   "Tenure": "Above 1 year to 15 months",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "6.85%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "6.75%"
//                 },
//                 "data10": {
//                   "Tenure": "Above 15 months to years",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "6.85%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "6.75%"
//                 },
//                 "data11": {
//                   "Tenure": "Above 2 years to 3 years",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "6.50%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "6.50%"
//                 },
//                 "data12": {
//                   "Tenure": "Above 3 years to 5 years",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "6.00%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "6.00%"
//                 },
//                 "data13": {
//                   "Tenure": "Above 5 years and up to 10 years",
//                   "Rate of Interest for Rs. 2.00 Crores up to Rs. 5.00 Crores": "5.00%",
//                   "Rate of Interest for Above Rs. 5.00 Crores up to Rs. 10.00 Crores": "5.00%"
//                 }
//               }
//             },
//             "note": "Bank of Baroda can change the interest rates at any given time without prior notice. The above-mentioned interest rates are effective from **16.04.2024.**"
//           },
//           "table4": {
//             "tableheading": "Bank of Baroda NRI FD Rates",
//             "tableheading1": "Bank of Baroda NRE FD Rates - Below Rs.2 crore (Callable)",
//             "tableContent": {
//               "headings": {
//                 "heading1": "Tenure",
//                 "heading2": "Rate of Interest (p.a.) "
//               },
//               "data": {
//                 "data1": {
//                   "Tenure": "1 year",
//                   "Rate of Interest (p.a.)": "6.85%"
//                 },
//                 "data2": {
//                   "Tenure": "Above 1 year – 400 days",
//                   "Rate of Interest (p.a.)": "6.85%"
//                 },
//                 "data3": {
//                   "Tenure": "Above 400 days - Up to 2 years",
//                   "Rate of Interest (p.a.)": "6.85%"
//                 },
//                 "data4": {
//                   "Tenure": "Above 2 years - Up to 3 years",
//                   "Rate of Interest (p.a.)": "7.25%"
//                 },
//                 "data5": {
//                   "Tenure": "Above 3 years - Up to 5 years",
//                   "Rate of Interest (p.a.)": "6.50%"
//                 },
//                 "data6": {
//                   "Tenure": "Above 5 years - Up to 10 years",
//                   "Rate of Interest (p.a.)": "6.50%"
//                 },
//                 "data7": {
//                   "Tenure": "399 Days (Baroda Tiranga Plus Deposit Scheme)",
//                   "Rate of Interest (p.a.)": "7.15%"
//                 }
//               }
//             },
//             "note": "Bank of Baroda can change the interest rates at any given time without prior notice. The above-mentioned interest rates are effective from **15 January 2024.**"
//           },
//           "table5": {
//             "tableheading": "Bank of Baroda FCNR FD Rates",
//             "tableContent": {
//               "headings": {
//                 "heading1": "Maturity Period",
//                 "heading2": "USD",
//                 "heading3": "USD 2 LACS TO 10 LACS",
//                 "heading4": "USD ABOVE 10 LACS",
//                 "heading5": "GBP",
//                 "heading6": "EUR",
//                 "heading7": "AUD",
//                 "heading8": "CAD"
//               },
//               "data": {
//                 "data1": {
//                   "Maturity Period": "1 Year",
//                   "USD": "5.50(5.50)",
//                   "USD 2 LACS TO 10 LACS": "5.80(5.80)",
//                   "USD ABOVE 10 LACS": "5.80(5.80)",
//                   "GBP": "5.00(5.00)",
//                   "EUR": "-",
//                   "AUD": "-",
//                   "CAD": "-"
//                 },
//                 "data2": {
//                   "Maturity Period": "Above 1 Yr. to less than 2 yrs.",
//                   "USD": "5.50(5.50)",
//                   "USD 2 LACS TO 10 LACS": "5.50(5.50)",
//                   "USD ABOVE 10 LACS": "5.50(5.50)",
//                   "GBP": "4.75(4.75)",
//                   "EUR": "1.50(1.50)",
//                   "AUD": "3.60(3.60)",
//                   "CAD": "4.50(4.50)"
//                 },
//                 "data3": {
//                   "Maturity Period": "2 Yrs. to less than 3 yrs.",
//                   "USD": "3.95(3.95)",
//                   "USD 2 LACS TO 10 LACS": "3.95(3.95)",
//                   "USD ABOVE 10 LACS": "3.95(3.95)",
//                   "GBP": "2.35(2.35)",
//                   "EUR": "1.50(1.50)",
//                   "AUD": "3.50(3.50)",
//                   "CAD": "4.10(4.10)"
//                 },
//                 "data4": {
//                   "Maturity Period": "3 Yrs. to less than 4 yrs.",
//                   "USD": "3.80(3.80)",
//                   "USD 2 LACS TO 10 LACS": "3.80(3.80)",
//                   "USD ABOVE 10 LACS": "3.80(3.80)",
//                   "GBP": "2.45(2.45)",
//                   "EUR": "1.50(1.50)",
//                   "AUD": "3.00(3.00)",
//                   "CAD": "3.85(3.85)"
//                 },
//                 "data5": {
//                   "Maturity Period": "4 Yrs. to less than 5 yrs.",
//                   "USD": "3.85(3.85)",
//                   "USD 2 LACS TO 10 LACS": "3.85(3.85)",
//                   "USD ABOVE 10 LACS": "3.85(3.85)",
//                   "GBP": "2.45(2.45)",
//                   "EUR": "1.50(1.50)",
//                   "AUD": "3.00(3.00)",
//                   "CAD": "3.90(3.90)"
//                 },
//                 "data6": {
//                   "Maturity Period": "5 Years",
//                   "USD": "3.90(3.90)",
//                   "USD 2 LACS TO 10 LACS": "3.90(3.90)",
//                   "USD ABOVE 10 LACS": "3.90(3.90)",
//                   "GBP": "2.45(2.45)",
//                   "EUR": "1.50(1.50)",
//                   "AUD": "3.00(3.00)",
//                   "CAD": "3.95(3.95)"
//                 }
//               }
//             },
//             "note": "Bank of Baroda can change the interest rates at any given time without prior notice. The above-mentioned interest rates are effective from **16 th April, 2024 – 15 th May, 2024. **"
//           },
//           "content": {
//             "content1": {
//               "heading": "Features and Benefits of Bank of Baroda Fixed Deposits",
//               "para": "The main features and benefits of the FD scheme offered by Bank of Baroda are mentioned below:",
      
//               "features": {
//                 "feature1": "The tenure of the scheme ranges between seven days and ten years.",
      
//                 "feature2": "Competitive interest rates are offered.",
      
//                 "feature3": "Nomination facility is provided.",
      
//                 "feature4": "Safe deposit lockers are provided.",
      
//                 "feature5": "Loans can be availed against the balance that is available in the account.",
      
//                 "feature6": "Convenient withdrawal options.",
      
//                 "feature7": "Outstation cheque collections."
//               }
//             },
      
//             "content2": {
//               "heading": "Eligibility Criteria",
//               "para": "The below-mentioned individuals and entities can open an FD account with Bank of Baroda:",
//               "eligibility1": {
//                 "category1": "Limited companies",
//                 "category2": "Associations, societies, and clubs",
//                 "category3": "Trusts",
//                 "category4": "Hindu Undivided Families (HUFs)",
//                 "category5": "Educational, charitable, and religious institutions",
//                 "category6": "Sole proprietorships",
//                 "category7": "Resident citizens",
//                 "category8": "Non-Resident Individuals (NRIs)",
//                 "category9": "Minors",
//                 "category10": "Partnership firms"
//               }
//             },
//             "content3": {
//               "heading": "Documents Required for Bank of Baroda FD",
//               "para": "Proof of address such as electricity bill, passport, or telephone bill"
//             }
//           }
        
      
//       }
      
//     )
//       .then((res)=>{
//         console.log(res)
//       })}}
    
//     >App</div>
//   )
// }



